export default __webpack_public_path__ + "static/media/profile9.46cf6e92.jpeg";